import typeCheck from 'common/util/typeCheck';

import { SR_API_ACTION_PARTNER_USER_GET_BY_USER_ID } from 'api/actionTypes';

export default async function loadCurrentPartnerUser(
  { state, apiClient },
  { userId, forceRefresh = false },
) {
  typeCheck('userId::PositiveNumber', userId);
  const currentPartnerUserStatePath = ['partners', 'currentPartnerUser'];
  if (state.get(currentPartnerUserStatePath) && !forceRefresh) {
    return state.get(currentPartnerUserStatePath);
  }
  return apiClient.postWithState({
    action: SR_API_ACTION_PARTNER_USER_GET_BY_USER_ID,
    queryId: String(userId),
    state: state,
    payload: {
      userId: userId,
    },
    onSuccess(partnerUser) {
      state.set(currentPartnerUserStatePath, partnerUser);
    },
  });
}
